module.exports = __webpack_public_path__ + "img/menActive.57aafce0.svg";